<template>
  <div>
    <common-table :table-columns="tableColumns"
                  :url="url" :operate="operate"
                  :form-fields="formFields"
                  :permission="permission"
                  :buttons="buttons"
                  :searchs="searchs"
                  @returnId="returnId"
                  @vieoUpdate="vieoUpdate"
                  ref="table"></common-table>
    <div class="dialog">
      <div class="dialog">
        <el-dialog title="批量修改代理"
                   :visible.sync="batchVisible"
                   custom-class="common-dialog"
                   :close-on-click-modal="false"
                   @close="resetForm('batchForm')"
                   width="30%">
          <div class="dialog_body">
            <el-form label-position="right" status-icon label-width="90px"
                     :model="batchForm" ref="batchForm">
              <el-form-item label="代理:" prop="agentId"
                            :rules="[{ required: true, message: '代理不能为空', trigger: 'blur'}]">
                <el-select
                    filterable
                    v-model="batchForm.agentId"
                    clearable
                    placeholder="请选择代理"
                    size="medium"
                    class="mr10 mb-10"
                >
                  <el-option
                      v-for="(option, index) in agentIdList"
                      :key="index"
                      :label="option.username"
                      :value="option.id"
                  />
                </el-select>
              </el-form-item>
            </el-form>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="batchVisible = false">取 消</el-button>
            <el-button type="primary" size="small" @click="submitBatch('batchForm')">确 定</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
    <div class="dialog">
      <el-dialog title="播放视频"
                 :visible.sync="showVideoVisible"
                 custom-class="common-dialog"
                 :close-on-click-modal="false"
                 width="30%">
        <video class="product_video" :loop="true" controls :autoplay="true" :src="videoSrc"></video>
        <div slot="footer" class="dialog-footer">
          <!-- <el-button size="small" @click="showVideoVisible = false">取 消</el-button> -->
          <el-button type="primary" size="small" @click="showVideoVisible = false">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable";
import message from "@/utils/message";
import request from "@/utils/axios";

export default {
  name: 'CuttingTask',
  components: {CommonTable},
  data() {
    return {
      videoSrc: '',
      showVideoVisible: false,
      selectIds: [],
      batchVisible: false,
      batchForm: {
        ids:'',
        agentId: ''
      },
      agentIdList:[],
      searchs: [{
        name: 'agentId',
        placeholder: '代理',
        type: 'select',
        selectUrl: '/agent/getAll',
        selectData: [],
      }, {
        name: 'title',
        placeholder: '剪辑标题',
        type: 'input'
      }, {
        name: 'clipName',
        placeholder: '剪映标签',
        type: 'input'
      },
        {
          name: 'status',
          placeholder: '状态',
          type: 'select',
          selectValue: [{
            key: 0,
            value: '未剪辑',
          }, {
            key: 1,
            value: '剪辑中',
          }, {
            key: 2,
            value: '剪辑完成',
          }]
        },  {
          name: 'linkConversionStatus',
          placeholder: '状态',
          type: 'select',
          selectValue: [{
            key: 0,
            value: '等待中',
          }, {
            key: 1,
            value: '进行中',
          }, {
            key: 2,
            value: '成功',
          }, {
            key: 3,
            value: '失败',
          }]
        }, {
          name: 'isRelease',
          placeholder: '是否预发布',
          type: 'select',
          selectValue: [{
            key: 0,
            value: '未发布',
          }, {
            key: 1,
            value: '已发布',
          },]
        },{
          name: 'productTemplateId',
          placeholder: '模板名称',
          type: 'select',
          selectUrl: '/productTemplate/getAll',
          selectData: [],
        },
        {
          name: 'devicesId',
          placeholder: '设备信息',
          type: 'select',
          selectUrl: '/devices/getAll',
          selectData: [],
        }
      ],
      permission: {
        add: 'cuttingTask:add',
        update: 'cuttingTask:update',
        delete: 'cuttingTask:delete',
        deleteBatch: 'cuttingTask:deleteBatch'
      },
      url: {
        get: '/cuttingTask/listByCondition',
        add: '/cuttingTask/add',
        update: '/cuttingTask/update',
        delete: '/cuttingTask/delete',
        delete_batch: '/cuttingTask/deleteBatch',
        status: '/cuttingTask/status',
      },
      tableColumns: [{
        field: 'id',
        label: 'Id',
        show: true,
        width: '100',
      },
        {
          field: 'agentId',
          label: '代理',
          selectUrl: '/agent/getAll',
          selectData: [],
          show: {
            type: 'select',
          },
          detail: false,
          width: '',
        }, {
          field: 'title',  // 字段名
          label: '剪辑标题',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,
        }, {
          field: 'clipName',  // 字段名
          label: '剪映标签',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,
        }, {
          field: 'productTemplateId',  // 字段名
          label: '模板名称',  // 字段显示名称
          sort: false,  // 是否排序
          selectUrl: '/productTemplate/getAll',
          selectData: [],
          show: {
            type: 'select',
          },
        }, {
          field: 'status',  // 字段名
          label: '状态',  // 字段显示名称
          sort: false,  // 是否排序
          show: {
            type: 'tag',
            tags: [{
              key: 0,
              value: '未剪辑',
              type: 'warning'
            }, {
              key: 1,
              value: '剪辑中',
              type: 'warning'
            }, {
              key: 2,
              value: '剪辑完成',
              type: 'success'
            }]
          },
        },{
          field: 'linkConversionStatus',  // 字段名
          label: '转链状态',  // 字段显示名称
          sort: false,  // 是否排序
          show: {
            type: 'tag',
            tags: [{
              key: 0,
              value: '等待中',
              type: 'info'
            }, {
              key: 1,
              value: '进行中',
              type: 'warning'
            }, {
              key: 2,
              value: '成功',
              type: 'success'
            } ,{
              key: 3,
              value: '失败',
              type: 'danger'
            }]
          },
        }, {
          field: 'leaderLink',  // 字段名
          label: '团长链接',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
        }, {
          field: 'url',  // 字段名
          label: '剪辑后视频URL',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
        }, {
          field: 'coverUrl',
          label: '封面',
          show: true,
          img: true,
        }, {
          field: 'productLink',
          label: '商品链接',
          show: true,
        }, {
          field: 'commission',
          label: '佣金',
          detail: false,
          show: true,
        }, {
          field: 'commissionRate',  // 字段名
          label: '佣金比例',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
        }, {
          field: 'sellingPrice',
          label: '售价',
          detail: false,
          show: true,
        },{
          field: 'images',  // 字段名
          label: '图片素材',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
        }, {
          field: 'videos',  // 字段名
          label: '视频素材',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
        }, {
          field: 'keyWord',  // 字段名
          label: '关键词',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
        }, {
          field: 'callBack',  // 字段名
          label: '回调日志',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
        }, {
          field: 'platformType',  // 字段名
          label: '平台类型',  // 字段显示名称
          sort: false,  // 是否排序
          show: {
            type: 'select',
          },
          selectData: [{
            id: 1,
            name: '抖音'
          }, {
            id: 2,
            name: '快手'
          }],
        }, {
          field: 'isRelease',  // 字段名
          label: '是否预发布',  // 字段显示名称
          sort: false,  // 是否排序
          show: {
            type: 'tag',
            tags: [{
              key: 0,
              value: '否',
              type: 'warning'
            }, {
              key: 1,
              value: '是',
              type: 'success'
            }]
          },
        },{
          field: 'productTemplateTitle',
          label: '模板标题',
          show: true,
        }, {
          field: 'devices',
          label: '设备名称',
          show: true,
        },{
          field: 'nasPath',
          label: 'nas数据存放地址',
          show: false,
          detail: true,
        },
        {
          field: 'createTime',
          label: '时间',
          show: true,
          width: '',
        }
      ],
      formFields: {
        addTitle: '添加',
        updateTitle: '修改',
        model: [
          {
            field: 'id',  // 字段名
            label: 'ID',  // 字段显示名称
            type: 'input',
            add: false,  // 是否添加
            update: true
          },
          {
            field: 'agentId',
            label: '代理：',
            type: 'select',
            placeholder: '请选择代理',
            rules: [{required: true, message: '请选择代理', trigger: 'blur'}],
            selectUrl: '/agent/getAll',
            selectData: [],
            add: true,
            update: true,
            filterable: true,
          }, {
            field: 'clipName',  // 字段名
            label: '剪辑名称',  // 字段显示名称
            type: 'input',
            placeholder: '请输入剪辑名称',
            rules: [
              {required: true, message: '剪辑名称不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'productTemplateId',  // 字段名
            label: '模板名称',  // 字段显示名称
            type: 'select',
            placeholder: '请选择模板',
            rules: [
              {required: true, message: '模板名称不能为空', trigger: 'blur'}
            ],
            selectUrl: '/productTemplate/getAll',
            selectData: [],
            add: true,
            update: true,
          }, {
            field: 'status',  // 字段名
            label: '状态',  // 字段显示名称
            type: 'select',
            placeholder: '请选择状态',
            rules: [
              {required: true, message: '状态不能为空', trigger: 'blur'}
            ],
            selectData: [{
              id: 0,
              name: '未剪辑'
            }, {
              id: 1,
              name: '剪辑中'
            }, {
              id: 2,
              name: '剪辑完成'
            }],
            add: false,
            update: true,
          }, {
            field: 'coverUrl',  // 字段名
            label: '封面',  // 字段显示名称
            type: 'input',
            placeholder: '请输入封面',
            rules: [
              {required: false, message: '封面不能为空', trigger: 'blur'}
            ],
            add: false,
            update: true,
          }, {
            field: 'productLink',  // 字段名
            label: '商品链接',  // 字段显示名称
            type: 'input',
            placeholder: '请输入商品链接',
            rules: [
              {required: false, message: '商品链接不能为空', trigger: 'blur'}
            ],
            add: false,
            update: true,
          }, {
            field: 'url',  // 字段名
            label: 'url',  // 字段显示名称
            type: 'input',
            placeholder: '请输入url',
            rules: [
              {required: true, message: 'url不能为空', trigger: 'blur'}
            ],
            add: false,
            update: false,
          }, {
            field: 'images',  // 字段名
            label: '图片素材',  // 字段显示名称
            type: 'input',
            placeholder: '请输入图片素材,多个以,号隔开',
            rules: [
              {required: false, message: '图片素材不能为空', trigger: 'blur'}
            ],
            add: false,
            update: true,
          }, {
            field: 'videos',  // 字段名
            label: '视频素材',  // 字段显示名称
            type: 'input',
            placeholder: '请输入视频素材,多个以,号隔开',
            rules: [
              {required: false, message: '视频素材不能为空', trigger: 'blur'}
            ],
            add: false,
            update: true,
          }, {
            field: 'keyWord',  // 字段名
            label: '关键词',  // 字段显示名称
            type: 'input',
            placeholder: '请输入关键词',
            rules: [
              {required: false, message: '关键词不能为空', trigger: 'blur'}
            ],
            add: false,
            update: true,
          }, {
            field: 'platformType',  // 字段名
            label: '平台',  // 字段显示名称
            type: 'select',
            placeholder: '请选择平台',
            rules: [
              {required: true, message: '平台不能为空', trigger: 'blur'}
            ],
            selectData: [{
              id: 1,
              name: '抖音'
            }, {
              id: 2,
              name: '快手'
            }],
            add: true,
            update: true,
          }, {
            field: 'callBack',  // 字段名
            label: 'callBack',  // 字段显示名称
            type: 'input',
            placeholder: '请输入callBack',
            rules: [
              {required: true, message: 'callBack不能为空', trigger: 'blur'}
            ],
            add: false,
            update: false,
          },
        ]
      },
      operate: [{
        icon: 'el-icon-video-camera',
        type: 'text',
        text: '播放存储mp4_url',
        playVideo2: true,
        handle: (row) => {
          console.log(row.url, '123123')
          if (row.url) {
            this. showVideoVisible= true
            this.videoSrc = row.url
          }
        },
      },{
        icon: 'el-icon-edit',
        type: 'text',
        text: '剪辑',
        exist: (row) => {
          return row.status === 0 && this.$refs.table.havePermission('cuttingTask:update')
        },
        handle: (row) => {
          if (row.status != 0) {
            message.warning("剪辑中，不可重复操作");
            return;
          }
          request.post({
            url: '/cuttingTask/update',
            data: {id: row.id, status: 1},
            success: (data) => {
              if (data.code == 0) {
                message.success("操作成功");
                this.$refs.table.getData();
              } else {
                message.error("操作失败");
              }
            }
          });
        }
      }
      ],
      buttons: [{
        icon: 'el-icon-circle-check',
        type: 'success',
        text: '批量发布',
        permission: 'cuttingTask:update',
        click: () => {
          console.log(this.selectIds)
          if (this.selectIds.length <= 0) {
            this.$message.warning('请选中要预发布的数据')
            return
          }
          // this.batchVisible = true;
          // this.batchForm.ids = this.selectIds.join(",")
          request.post({
            url: '/cuttingTask/batchRelease',
            data: {"ids": this.selectIds.join(",")},
            success: (data) => {
              if (data.code === 0) {
                message.success("批量预发布成功");
                this.$refs.table.getData()
              } else {
                message.error(data.msg);
              }
            }
          });
        }
      },{
        icon: 'el-icon-circle-check',
        type: 'info',
        text: '批量修改代理',
        permission: 'douYinRelease:update',
        click: () => {
          console.log(this.selectIds)
          if (this.selectIds.length <= 0) {
            this.$message.warning('请选中要修改的数据')
            return
          }
          request.post({
            url: '/agent/getAll',
            success: (data) => {
              if (data.code == 0) {
                console.log(data)
                this.agentIdList = data.data;
                this.batchForm.ids = this.selectIds.join(",")
                this.batchVisible = true
              }
            }
          });
        }
      }],
    }
  },
  methods: {
    returnId(data) {
      this.selectIds = data;
      console.log(this.selectIds)
    },vieoUpdate(data) {
      this.operate[0].value = data
      this.$refs.table.getData()
    },    //重置表单
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    submitBatch(formName) {
      console.log(this.batchForm, "123123")
      this.$refs[formName].validate((valid) => {
        if (valid) {
          request.post({
            url: '/cuttingTask/batchAgent',
            data: this.batchForm,
            confirm: '确定批量预发布成功？',
            success: (data) => {
              if (data.code === 0) {
                message.success("批量预发布成功");
                this.batchVisible = false;
                this.$refs.table.getData()
              } else {
                message.error(data.msg);
              }
            }
          });
        }
      })
    },
  }
}
</script>

<style scoped>

</style>
